<style src="css/articleDetail.css" scoped></style>cdn.ysqingxin.com
<template>
    <div style="padding-top: 1rem;padding-bottom: 1.2rem">
        <topbar text="精品文章" :status="true"></topbar>
        <div class="mainBox">
            <div class="articleTitle">{{articleDetail.title}}</div>
            <div class="authorBox">作者：{{articleDetail.author}} <span>{{articleDetail.createTime | time}}</span></div>
            <div class="contentBox" v-html="articleDetail.content"></div>

<!--            <div class="clickBox">-->
<!--                <div class="handBase">-->
<!--                    <div class="hand" :class="{active:handMove}"></div>-->
<!--                </div>-->
<!--                <div class="boldWord">问题没解决？找专家咨询一下</div>-->
<!--                <div class="allDay">知名专家24小时回复</div>-->
<!--                <div class="clickBtn" @click="to('ask')"></div>-->
<!--            </div>-->
        </div>
        <div class="commentBox">
            <div class="modeTitle">
                全部评论({{count}}):
                <div></div>
            </div>
            <ul>
                <li v-for="item in articleCommentList">
                    <div class="userBox">
                        <div class="userImg"></div>
                        <div class="userTopRightBox">
                            <div class="name">{{item.nickName}}</div>
                            <div class="time">{{item.createTime|time}}</div>
                        </div>
                    </div>
                    <div class="userContent">{{item.content}}</div>
                </li>
            </ul>

        </div>
        <div class="maskBox" v-if="mask">
            <div class="inputBox">
                <div class="inputTop"><span @click="cancle()">取消</span> <span @click="commitArticleComment">提交</span></div>
                <textarea autofocus id="textarea" v-model="content" placeholder="写下你的看法吧！"></textarea>
            </div>
        </div>
        <div class="fixedBox">
            <div class="input" @click="openMask()">
                <div class="inputIcon"></div>
                发表评论
            </div>
            <div class="fabulous" :class="{active:likeStatus}" @click="doLoveArticle()">
                <div class="c-num">{{articleDetail.loveCount}}</div>
            </div>
            <div class="toTeacher"  @click="to('ask')">咨询老师</div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'


    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
                mask:false,
                content:'',
                likeStatus:false,
                handMove:false,
                articleDetail:{},
                articleCommentList:[],
                roleMenuList: [
                    {display: true},
                    {display: true},
                    {display: true},
                    {display: true},
                    {display: true},
                    {display: true},
                ],
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `//picture.itnbear.com/`,
                scaleInfoDetail: {},
                txList: [],
                explainMain: [
                    {
                        content1: '每次下单仅能测试一次，若需要多次测试，可以重复下单。',
                        span: '',
                        content2: '',
                    },
                    {
                        content1: '如果在测试过程中遇到问题，可通过',
                        span: '【我的-联系我们】',
                        content2: '，留言反馈给我们',
                    },
                    {
                        content1: '测试结果会保存在',
                        span: '【我的-我的测试】',
                        content2: '中，进入即可继续答题或查看测试结果。',
                    },
                    {
                        content1: '虚拟商品一经出售不予退款。',
                        span: '',
                        content2: '',
                    },
                ],
                scaleId: '',
                userId: '',
                testId: '',

                slidesReal: [],
                scaleLabelList: [],
                scaleUserTestList: [],
                indexNum: -1,
                labelId: '',
                pageIndex: 1,
                pageSize: 4,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                count: 0,
                testStatus: 0,
                isCompanyId: true,
                scaleUser: {
                    companyId: '',
                },

            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            cancle(){
                this.mask=false;
            },
            openMask(){
                    this.mask=true;
            },
            back() {
                history.back()
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            handtoggle(){
                setInterval(()=>{
                    this.handMove=!this.handMove
                },500)
            },
            async getArticleCommentList() {
                let data = await getSources("/bear-scale/api/micro/getArticleCommentList.json", {
                    pageIndex:1,
                    pageSize:20,
                    articleId:this.articleId
                });
                if (data.status === 0) {
                    this.articleCommentList=data.articleCommentList
                    this.count=data.count
                }else{
                    alert(data.msg)
                }
            },
            init(){
                this.content='';
                this.mask=false;
            },
            async commitArticleComment() {
                if(!this.content){
                    alert('请您输入评论内容~')
                }else{
                    let data = await getSources("/bear-scale/api/micro/commitArticleComment.json", {
                        articleId:this.articleId,
                        userId:this.userId,
                        content:this.content
                    });
                    if (data.status === 0) {
                        this.getArticleCommentList();
                        this.init();
                    }else{
                        alert(data.msg)
                    }
                }
            },
            async doLoveArticle() {
                let data = await getSources("/bear-scale/api/micro/doLoveArticle.json", {
                    articleId:this.articleId
                });
                if (data.status === 0) {
                    this.likeStatus=true;
                    this.getMicroDetail()
                }else{
                    alert(data.msg)
                }
            },

            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.search()
                    }
                }
            },
            async getMicroDetail() {
                let obj = {}
                obj.articleId = this.$route.query.articleId;
                let data = await getSources("/bear-scale/api/micro/getArticleDetail.json", obj);
                if (data.status === 0) {
                    this.articleDetail = data.articleDetail
                }else{
                    alert(data.msg)
                }
            },

        },
        mounted() {
            this.userId = localStorage.getItem('userId');
            this.articleId=this.$route.query.articleId;
            this.getArticleCommentList();
            this.getMicroDetail();
            this.handtoggle();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/articleDetail.vue?1e2438cb